var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Feedback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-166.000000, -538.000000)",
    stroke: "#31383E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Feedback",
    transform: "translate(167.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14503797,19.8470127 L7.24807595,17.7439747",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.7019747 L2.10303797,12.5989367",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87331646,11.9736962 L19.8469873,2.53164557e-05",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.8470127 L5.24531646,14.6016962",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    points: "19.8470127 0 11.6958734 19.8470886 7.87334177 11.9736709 -7.59493671e-05 8.15113924"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoFeedback);
export default __webpack_public_path__ + "static/media/PictoFeedback.e518f53294a2701445232ab482386ee5.svg";
export { ForwardRef as ReactComponent };